import { render, staticRenderFns } from "./Item2RowLinkEl.vue?vue&type=template&id=b40b1812&scoped=true&"
import script from "./Item2RowLinkEl.vue?vue&type=script&lang=ts&"
export * from "./Item2RowLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./Item2RowLinkEl.vue?vue&type=style&index=0&id=b40b1812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40b1812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
